import { createGlobalStyle } from 'styled-components';
import RubikLight from 'src/assets/fonts/Rubik/static/Rubik-Light.ttf';
import RubikRegular from 'src/assets/fonts/Rubik/static/Rubik-Regular.ttf';
import RubikMedium from 'src/assets/fonts/Rubik/static/Rubik-Medium.ttf';
import { addRootConfig } from './helpers';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Rubik';
    src: url(${RubikLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: 'Rubik';
    src: url(${RubikMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: auto;
  }
  
  * {
    box-sizing: border-box;
  }

  :root {
    ${addRootConfig()}
  }
  
  html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }
  
  body {
    margin: 0;
    font-family: var(--typography-sans-serif), sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, p {
    margin: 0;
  }
  
  h2 {
    font-size: 36px;
    font-weight: 300;
    letter-spacing: -1px;
    line-height: 30px;
    margin-bottom: calc(var(--margin-base) / 2);
  }
  
  a {
    color: var(--light-blue);
    transition: all 0.4s cubic-bezier(0.17, 0.67, 0.83, 0.67);
    
    &:hover,
    &:focus {
      color: var(--primary);
    }
  }
  
  .btn-success {
      background-color: var(--success) !important;
      display: block;
      margin: calc(var(--margin-base) / 2) auto 0;
      padding: calc(var(--padding-base) / 3) calc(var(--padding-base) * 2);
  }
`;
